@let blok = block();
@for (child of blok.children; track child._uid) {
    <s1-cms-component [blok]="child">
    </s1-cms-component>
}
